import TextWithEllipse from "./TextWithEllipse";

export default TextWithEllipse